module.exports = __webpack_public_path__ + "img/header-weddingRingsDiamonds.e24cb85.jpg";